<template>
  <div id="identity">
    <v-title
      tit-icon="sign-in-alt"
      tit-text="請選擇登入身分"
    />
    <div class="container">
      <div class="row">
        <!-- 在學生(含休/退學) -->
        <div class="col-sm div-center pt-2">
          <router-link
            class="btn btn-outline-light"
            role="button"
            style="color: #000;"
            :to="{ name: 'Home_Login', params: { identity: 'student' } }"
          >
            <font-awesome-icon
              icon="user"
              size="5x"
            />
            <br>
            <span class="small-color">在學生(含休/退學)</span>
          </router-link>
        </div>
        <!-- 畢業校友 -->
        <div class="col-sm div-center pt-2">
          <router-link
            class="btn btn-outline-light"
            role="button"
            style="color: #000;"
            :to="{ name: 'Home_Login', params: { identity: 'graduate' } }"
          >
            <font-awesome-icon
              icon="user-graduate"
              size="5x"
            />
            <br>
            <span class="small-color">畢業校友</span>
          </router-link>
        </div>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import vTitle from '@/components/Features/Title'
export default {
  name: 'Registered',
  components: {
    vTitle
  }
}
window.FontAwesomeConfig = {
  searchPseudoElements: true
}
</script>
<style lang="scss">
.small-color {
  color: red;
  font-weight: bold;
}
</style>
